import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { gaPageView } from '../lib/ga';
import { trackPageview } from '../lib/metrics';
import { privateTelemetryUrl, enterPrivateTelemetry, telemetryIsPrivate } from '../lib/telemetryPrivacy';

/** Sends a GA4 page_view + first-party count on every client-side route
 *  change. Small delay lets BrandSEO update document.title first. */
export const AnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    if (privateTelemetryUrl(location.pathname + location.search)) enterPrivateTelemetry();
    if (telemetryIsPrivate()) return undefined;
    const path = location.pathname + location.search;
    const t = setTimeout(() => {
      if (telemetryIsPrivate()) return;
      gaPageView(path);
      trackPageview(location.pathname);
    }, 250);
    return () => clearTimeout(t);
  }, [location.pathname, location.search]);

  return null;
};
